// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { SurfaceSubsidiarySchema } from './SurfaceSubsidiarySchema'
import type { SurfaceSubsidiary } from './SurfaceSubsidiarySchema'
import { SurfaceDivisionSchema } from './SurfaceDivisionSchema'
import type { SurfaceDivision } from './SurfaceDivisionSchema'
import { ExternalNetworkProfileSchema } from './ExternalNetworkProfileSchema';

/////////////////////////////////////////
// EXTERNAL NETWORK PROFILE RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkProfileRelations = {
  surface: ExternalNetworkWithRelations;
  subsidiaries: SurfaceSubsidiary[];
  divisions: SurfaceDivision[];
};

export type ExternalNetworkProfileWithRelations = z.infer<typeof ExternalNetworkProfileSchema> & ExternalNetworkProfileRelations

export const ExternalNetworkProfileWithRelationsSchema: z.ZodType<ExternalNetworkProfileWithRelations> = ExternalNetworkProfileSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  subsidiaries: z.lazy(() => SurfaceSubsidiarySchema).array(),
  divisions: z.lazy(() => SurfaceDivisionSchema).array(),
}))